"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingDirectoryWrap = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var styles_1 = require("@material-ui/styles");
var MenuItem_1 = tslib_1.__importDefault(require("@material-ui/core/MenuItem"));
var index_1 = require("../../index");
var useStyles = styles_1.makeStyles(function (theme) { return ({
    SettingDirectory: {
        display: "flex",
        flexDirection: "column",
    },
    MenuItem: {
        height: 32,
        width: "100%",
        marginBottom: 2,
        "&:hover": {
            borderRadius: 3,
        },
    },
    SettingDirectoryDefalt: {
        height: 32,
        width: "100%",
    },
    SettingDirectoryChoosed: {
        height: 32,
        backgroundColor: theme.app.SettingDirectory.backgroundColor,
        width: "100%",
        borderRadius: 3,
    },
    SettingItemDefault: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        color: theme.app.Setting.color4,
        "&:hover": {
            color: theme.app.Setting.color3,
        },
        textDecoration: "none",
    },
    SettingItemChoosed: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        color: theme.app.Setting.color3,
        textDecoration: "none",
    },
    divider: {
        marginLeft: 10,
        marginRight: 10,
        opacity: 0.5,
    },
}); });
function SettingDirectoryWrap(props) {
    var data = props.data;
    var _a = tslib_1.__read(react_1.useState(""), 2), option = _a[0], SetOption = _a[1];
    var classes = useStyles();
    var handleOption = function (newoption) {
        SetOption(newoption);
        console.log(option);
    };
    return (react_1.default.createElement("div", null,
        data.map(function (item, index) { return (react_1.default.createElement("div", { key: index, className: classes.SettingDirectory },
            react_1.default.createElement("div", null,
                react_1.default.createElement(index_1.DirectoryTitle, null, item.title)),
            react_1.default.createElement("div", null, item.nodes.map(function (subItem, subIndex) { return (react_1.default.createElement("div", { key: subIndex },
                option !== subItem.title && (react_1.default.createElement(MenuItem_1.default, { disableGutters: true, className: classes.MenuItem, onClick: function () { return handleOption(subItem.title); } },
                    react_1.default.createElement("div", { className: classes.SettingDirectoryDefalt },
                        react_1.default.createElement(react_router_dom_1.Link, { to: subItem.url, className: classes.SettingItemDefault },
                            react_1.default.createElement(index_1.DirectoryView, null,
                                subItem.title,
                                " "))))),
                option === subItem.title && (react_1.default.createElement(MenuItem_1.default, { disableGutters: true, className: classes.MenuItem, onClick: function () { return handleOption(subItem.title); } },
                    react_1.default.createElement("div", { className: classes.SettingDirectoryChoosed },
                        react_1.default.createElement(react_router_dom_1.Link, { to: subItem.url, className: classes.SettingItemChoosed },
                            react_1.default.createElement(index_1.DirectoryView, null,
                                subItem.title,
                                " "))))))); })),
            index !== data.length && (react_1.default.createElement("div", { className: classes.divider },
                react_1.default.createElement(index_1.LayoutContainerTB8px, null,
                    react_1.default.createElement(index_1.Divider, null)))))); }),
        react_1.default.createElement(index_1.DirectoryView, { color: "red" }, "\u767B\u51FA"),
        react_1.default.createElement("div", { className: classes.divider },
            react_1.default.createElement(index_1.LayoutContainerTB8px, null,
                react_1.default.createElement(index_1.Divider, null)))));
}
exports.SettingDirectoryWrap = SettingDirectoryWrap;
//# sourceMappingURL=SettingDirectoryWrap.js.map